import {
  get as baseGet,
  post as basePost,
  getUserInfo,
  login,
} from '@didi/spring-base'

// 需要 loading 的接口
const withLoadingList = []

const request = (fn) => {
  return async (url, params, options = {}) => {
    const userInfo = await getUserInfo()
    const _options = {
      loading: withLoadingList.includes(url),
      ...options,
      header: {
        token: userInfo.token,
        ...options.header,
      },
    }
    return fn(url, params, _options).then(res => {
      if ([10401, 10402].includes(res.code)) {
        login().catch(() => {})
      }
      return res
    })
  }
}

const get = request(baseGet)
const post = request(basePost)

export {
  get,
  post,
}
